import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    SoundType,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import { RopesLogic } from '../../../Logic/MiniGames/RopesLogic';
import { RopesModel } from '../../../Models/MiniGames/RopesModel';
import { RopesButtonController } from './RopesButtonController';
import { RopesBackgroundController } from './RopesBackgroundController';
import { GameLogic } from '../../../Logic/GameLogic';
import { DialogTextEnum, DialogTypeTextEnum } from '../../../Models/GameModel';
import { SoundConstants, SoundLevels } from '../../../Constants/SoundConstants';

export interface IRopesGameControllerOptions {
    onComplete: () => void;
}

export class RopesGameController extends AnimationBaseController {
    public $model: RopesModel;

    private _width: number = 0;
    private _height: number = 0;

    private _highlightTimeoutId: number = -1;

    public constructor(
        @Inject private _options: IRopesGameControllerOptions,
        @Inject private _ropesLogic: RopesLogic,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('RopesGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.ROPES_GAME_SCREEN_JSON,
            libraryName: 'mini_game_unmoor',
            sounds: [
                {
                    id: SoundConstants.ROPES_CUTTING,
                    type: SoundType.SFX,
                },
            ],
            childControllers: {
                backgroundController: {
                    instanceName: 'background',
                    controller: RopesBackgroundController,
                    options: {
                        onClick: () => {
                            debugger;
                            this.$model.color.forEach((color, i) => {
                                debugger;
                                if (this._isRopeInteractive(color, i)) {
                                    this._changeRopeAnimation(
                                        color,
                                        i,
                                        'hover',
                                    );

                                    clearTimeout(this._highlightTimeoutId);

                                    this._highlightTimeoutId = setTimeout(
                                        () => {
                                            this.$model.color.forEach(
                                                (color, i) => {
                                                    if (
                                                        this._isRopeInteractive(
                                                            color,
                                                            i,
                                                        )
                                                    ) {
                                                        this._changeRopeAnimation(
                                                            color,
                                                            i,
                                                            'normal',
                                                        );
                                                    }
                                                },
                                            );
                                        },
                                        2 * 1000,
                                    );
                                }
                            });
                        },
                    },
                },

            },
            queue: {
                win: {
                    condition: clock => clock > 0.2,
                    action: () => {
                        this._gameLogic.showDialogScreen(DialogTextEnum.ropes, DialogTypeTextEnum.end, 0, () => this._options.onComplete());
                    },
                },
                normal: {
                    condition: clock => clock > 0.3,
                    action: (clock, { color, index }) => {
                        this._changeRopeAnimation(color, index, 'normal');
                    },
                },
                empty: {
                    condition: clock => clock > 0.3,
                    action: (clock, { color, index }) => {
                        this._changeRopeAnimation(color, index, 'empty');
                    },
                },
            },
        } as IAnimationControllerConfiguration;
    }

    protected onInitialize(): void {
        this._gameLogic.showDialogScreen(DialogTextEnum.ropes, DialogTypeTextEnum.start);

        this.$model.color.forEach((color, i) => {
            this.addChildController(
                {
                    instanceName: `${color}_${i}`,
                    controller: RopesButtonController,
                    model: this.$model,
                    options: {
                        color: color,
                        index: i,
                        onClick: (color, i) => {
                            if (this._isRopeInteractive(color, i)) {
                                clearTimeout(this._highlightTimeoutId);

                                this.$model.color.forEach((color, i) => {
                                    if (this._isRopeInteractive(color, i)) {
                                        this._changeRopeAnimation(
                                            color,
                                            i,
                                            'normal',
                                        );
                                    }
                                });

                                this.gotoAndStopByQuery(
                                    `${color}_${i}`,
                                    'hover',
                                );
                                console.log(this.$model);
                                if (this._ropesLogic.checkRightColors(color)) {
                                    this.$queue
                                        .get('empty')
                                        .addToQueue(1, {
                                            color: color,
                                            index: i,
                                        });

                                    this._changeRopeInteractive(color, i);
                                    this._ropesLogic.increaseRightAnswer();
                                    if ((this.$model.rightAnswers) === 6) {
                                        this.$queue.get('win').addToQueue(2);
                                        this._ropesLogic.reset();
                                    }

                                    if (
                                        this.$model.rightAnswers === 2 ||
                                        this.$model.rightAnswers === 4 ||
                                        this.$model.rightAnswers === 6
                                    ) {
                                        this._ropesLogic.setWrongAnswer(0);
                                        this._ropesLogic.increaseRoundIndex();
                                    }
                                } else {
                                    this._ropesLogic.increaseWrongAnswer();

                                    let hintIndex = this.$model.roundIndex;

                                    if (
                                        this.$model.roundIndex === 1 &&
                                        this.$model.wrongAnswers > 1
                                    ) {
                                        hintIndex++;
                                    }

                                    this._gameLogic.showDialogScreen(DialogTextEnum.ropes, DialogTypeTextEnum.hint, hintIndex);

                                    this._changeRopeAnimation(
                                        color,
                                        i,
                                        'wrong',
                                    );

                                    this.$queue
                                        .get('normal')
                                        .addToQueue(1, {
                                            color: color,
                                            index: i,
                                        });
                                }
                            }
                        },
                    },
                },
                `${color}_${i}`,
            );
        });

        this._width = 3000;
        this._height = 1440;
    }

    private _changeRopeInteractive(color: string, i: number): void {
        this.$childControllers[`${color}_${i}`].controller.display.interactive =
            false;
        this.soundManager.playSound(SoundConstants.ROPES_CUTTING, 0, SoundLevels.MINIGAME_ACTION);
    }

    private _isRopeInteractive(color: string, i: number): boolean {
        debugger;
        return this.$childControllers[`${color}_${i}`].controller.display
            .interactive;
    }

    private _changeRopeAnimation(
        color: string,
        i: number,
        positionOrLabel: string | number,
    ): void {
        this.gotoAndStopByQuery(`${color}_${i}`, positionOrLabel);
    }

    protected onResize(width: number, height: number, scale: number) {
        const scaleValue = Math.min(width / scale / this._width, height / scale / this._height);

        this.scaleX = scaleValue;
        this.scaleY = scaleValue;
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }
}
